import React, { useCallback } from 'react'
import { css } from '@emotion/react'
import { useDispatch, useSelector } from 'react-redux'
import { SVGIcon, Tooltip } from 'shared/ui'
import { selectIsMatrixClientReady } from 'ducks/chat/selectors/client'
import { doUpdateAudioNotificationsFromUI } from 'ducks/chat/actions/notifications'
import { selectNotificationsEnabled } from 'ducks/chat/selectors/notifications'
import { isDenied } from 'util/webPush/permissions'

const buttonStyle = () => theme => css`
  cursor: pointer;
  color: ${theme.color.monochrome.mediumDark} !important;
  margin-top: -4px;
`

const NotificationsButton = props => {
  const clientReady = useSelector(selectIsMatrixClientReady)
  const enabled = useSelector(selectNotificationsEnabled)
  const dispatch = useDispatch()
  const onToggle = useCallback(
    () => {
      if (isDenied()) return
      dispatch(doUpdateAudioNotificationsFromUI(!enabled))
    },
    [dispatch, enabled]
  )

  if (!clientReady) return null

  return (
    <div {...props}>
      <Tooltip
        key="link"
        portal
        position="bottom"
        tooltip={
          isDenied() &&
          'You have blocked notifications in your browser permissions.'
        }
      >
        <SVGIcon
          name={`notifications${enabled ? 'Active' : 'Off'}`}
          size={16}
          css={buttonStyle}
          onClick={onToggle}
        />
      </Tooltip>
    </div>
  )
}

export default NotificationsButton
